module.exports = __webpack_public_path__ + "img/en-slider_text_d2.7b439e49.png";